module.exports = __webpack_public_path__ + "static/media/asset_dashboard_mobile.19489a6f.png";